import { render, staticRenderFns } from "./NewAppBundleFlow.vue?vue&type=template&id=5b8861ba"
import script from "./NewAppBundleFlow.vue?vue&type=script&lang=js"
export * from "./NewAppBundleFlow.vue?vue&type=script&lang=js"
import style0 from "./NewAppBundleFlow.vue?vue&type=style&index=0&id=5b8861ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports